import {AES} from "../libs/Crypto"
import IPassword, { IKeyVal } from "../shared/Password"
import * as _ from "lodash"
import {db,drop} from "./PassDB"

export interface IUserPassword {
    data:Record<string,string>
    ts:number
}

interface IAuth {
    data:IPassword[]
}

export default class Auth implements IAuth{
    private _aes:AES = new AES()
    private _passwords:IPassword[] = []
    private _db = db.password

    async init(json:IUserPassword|null, password:string){
        await this._aes.init(password)

        const rows = await this._db.toArray()
        console.log("rows", rows)
        for(const row of rows){
            try {
                if (json?.data && !(row.id in json.data)) this._db.delete(row.id).catch(this._muck)
                else this._passwords.push(JSON.parse(await this._aes.decrypt(row.value)))
            }catch(e){
                console.log(e)
                throw {status:401, msg:"Password is incorrect"}
            }
        }

        if (json) {
            for(const id in json.data){
                try {
                    const row = rows.find(p => p.id==id)
                    if (row){
                        if (row.value != json.data[id]) {
                            this._db.update(id, {value:json.data[id]}).catch(this._muck)
                            _.remove(this._passwords, p => p.id==id)
                            this._passwords.push(await this.decrypt(json.data[id]))
                        }
                    }
                    else {
                        this._passwords.push(await this.decrypt(json.data[id]))
                        this._db.add({id, value:json.data[id]}).catch(this._muck)
                    }
                }catch(e){
                    console.log("Failed to decrypt password", e)
                }
            }
        }

        return this.sort()
    }
    async clear(){
        drop()
    }

    get data():IPassword[]{return this._passwords}

    async decrypt(value:string) : Promise<IPassword> {
        try {
            return JSON.parse(await this._aes.decrypt(value))
        }catch(e){
            console.log("decrypt failed")
            throw {status:401}
        }
    }
    encrypt(row:IPassword) {
        return this._aes.encrypt(JSON.stringify(row))
    }

    get(id:string){
        return this._passwords.find(p => p.id==id)
    }

    add(row:IPassword, value:string){
        this._passwords.push(row)
        this.sort()
        this._db.add({id:row.id,value}).catch(this._muck)
    }

    async updatePassword(old:string, password:string){
        const encrypted = await this._aes.encrypt("test")
        const aes = await (new AES()).init(old)
        try {
            await aes.decrypt(encrypted)
        }catch(e){
            throw {status:401, msg:"Password is incorrect"}
        }
        await this._aes.init(password)
        const rows : Record<string,string> = {}
        for(const row of this._passwords){
            const value = await this.encrypt(row)
            rows[row.id] = value
            this._db.update(row.id, {value})
        }
        return rows
    }

    async create(name:string){
        const row = {id:crypto.randomUUID().replace(/\-/g, ""),name,data:[]}
        const value = await this.encrypt(row)
        this._passwords.push(row)
        await this._db.add({id:row.id,value})
        return {id:row.id,value}
    }

    async update(id:string, data:IKeyVal[]) {
        const row = this._passwords.find(p => p.id==id)
        if (!row) throw {status:404,msg:`password id=${id} not found`}

        row.data = data
        const value = await this.encrypt(row)
        await this._db.update(id, {value})
        return value
    }

    async findAndUpdate(id:string, value:string){
        const index = _.findIndex(this._passwords, p => p.id==id)
        const row = await this.decrypt(value)
        if (index>=0){
            this._passwords[index] = row
            await this._db.update(id, {value})
        }else{
            this._passwords.push(row)
            await this._db.add({id,value})
        }
    }

    delete(id:string){
        _.remove<IPassword>(this._passwords, p => p.id==id)
        this._passwords = [...this._passwords]
        return this._db.delete(id)
    }
    sort(){
        this._passwords.sort((l,r) => l.name.localeCompare(r.name))
        return this
    }
    private _muck(){}
}